<div *ngIf="canLoad && charity; else hideContentBlock" class="donation-counter">
  <div class="donation-counter__panel-content">
    <div class="donation-counter__text">
      <span class="h3">{{ charity.title }}</span>
      <h2>{{ content.title }}</h2>
      <div [internalInnerHtml]="content.description" [userEventSource]="userEventSource"></div>

      <div *ngIf="link" class="button__group">
        <a class="button button--cta" [airLink]="link" [userEventSource]="userEventSource">
          {{ link.label }}
        </a>
      </div>
    </div>

    <div class="donation-counter__image">
      <figure>
        <air-focal-image [image]="charity.primaryImage"></air-focal-image>
      </figure>
    </div>
  </div>
  <div class="donation-counter__panel-item donation-counter__panel-counter">
    <air-counter #counter [label]="'Totaal aantal gedoneerde Air Miles'"></air-counter>
  </div>
</div>

<ng-template #hideContentBlock>
  <div class="donation-counter__unload"></div>
</ng-template>
